import { toMartSource } from 'src/pages/reports/utils/format-reporting-labels';

interface BuildReportingBetaHrefInput {
  platform: string;
  campaignId: string;
  campaignName?: string;
  startDate: string;
  endDate: string;
}

/** Deep link into Reporting (Beta) with platform, campaign, and date range prefilled. */
export function buildReportingBetaHref(input: BuildReportingBetaHrefInput): string {
  const params = new URLSearchParams({
    source: toMartSource(input.platform),
    campaign: input.campaignId,
    startDate: input.startDate,
    endDate: input.endDate,
  });
  if (input.campaignName) {
    params.set('campaignName', input.campaignName);
  }
  return `/reports/reporting-beta?${params.toString()}`;
}
